<template>
  <div class="header-nav">
    <div class="content">
      <!-- 导航logo -->
      <img class="header-nav-logo" src="../../static/image/Header/logo.png" />
      <!-- 导航内容 -->
      <div class="nav_content">
        <ul class="header-nav-wrapper" ref="navRef">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @mouseenter="showDropDown(index)"
            @click="navClick(index, item.name)"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <!-- <i class="underline"></i> -->
            </router-link>
          </li>
        </ul>
        <!-- 下拉菜单 -->
        <transition name="dropdown">
          <div
            v-show="isShow"
            class="dropdown-content"
            @mouseleave="hideDropDown"
          >
            <div class="left">
              <div
                class="option"
                v-for="(item, index) in productList"
                :key="index"
                @mouseenter="getDropFlag(index)"
              >
                <img :src="item.imgUrl" />
                <div class="select_box">
                  <p class="name">{{ item.name }}</p>
                  <p class="introduce">{{ item.tip }}</p>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="option_detail" v-show="activityFlag == 0">
                <div class="option_box">
                  <div class="title_name">
                    {{ $t("lang.ProductSolutions.index.kjjr") }}
                  </div>
                  <div class="line_box">
                    <span class="red_line"></span>
                    <span class="line2"></span>
                  </div>
                  <div
                    class="text"
                    v-for="item in options1"
                    :key="item.name"
                    @click="toRouter(item.router)"
                  >
                    {{ item.name }}
                    <img
                      v-if="item.isHot ? item.isHot : item.isNew"
                      :src="
                        item.isHot
                          ? '../../static/image/Header/hot.png'
                          : item.isNew
                          ? '../../static/image/Header/new.png'
                          : ''
                      "
                    />
                  </div>
                </div>
                <div class="option_box">
                  <div class="title_name">
                    {{ $t("lang.ProductSolutions.index.jryw") }}
                  </div>
                  <div class="line_box">
                    <span class="red_line"></span>
                    <span class="line2"></span>
                  </div>
                  <div
                    class="text"
                    v-for="item in options2"
                    :key="item.name"
                    @click="toRouter(item.router)"
                  >
                    {{ item.name
                    }}<img
                      v-if="item.isHot ? item.isHot : item.isNew"
                      :src="
                        item.isHot
                          ? '../../static/image/Header/hot.png'
                          : item.isNew
                          ? '../../static/image/Header/new.png'
                          : ''
                      "
                    />
                  </div>
                </div>
                <div class="option_box">
                  <div class="title_name">
                    {{ $t("lang.ProductSolutions.index.hxjr") }}
                  </div>
                  <div class="line_box">
                    <span class="red_line"></span>
                    <span class="line2"></span>
                  </div>
                  <div
                    class="text"
                    v-for="item in options3"
                    :key="item.name"
                    @click="toRouter(item.router)"
                  >
                    {{ item.name
                    }}<img
                      v-if="item.isHot ? item.isHot : item.isNew"
                      :src="
                        item.isHot
                          ? '../../static/image/Header/hot.png'
                          : item.isNew
                          ? '../../static/image/Header/new.png'
                          : ''
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="option_detail" v-show="activityFlag == 1">
                <div class="option_box">
                  <!-- <div class="title_name">{{ $t('lang.ProductSolutions.index.kjjr') }}</div> -->
                  <!-- <div class="line_box">
                    <span class="red_line"></span>
                    <span class="line2"></span>
                  </div> -->
                  <div
                    class="text"
                    v-for="item in options4"
                    :key="item.name"
                    @click="toRouter(item.router)"
                  >
                    {{ item.name
                    }}<img
                      v-if="item.isHot"
                      src="../../static/image/Header/hot.png"
                    />
                  </div>
                </div>
                <div class="option_box">
                  <!-- <div class="title_name">金融业务</div>
                  <div class="line_box">
                    <span class="red_line"></span>
                    <span class="line2"></span>
                  </div> -->
                  <!-- <div class="text" v-for="item in options4" :key="item.name" @click="toRouter(item.router)">{{ item.name }}<img v-if="item.isHot" src="../../static/image/Header/hot.png" /></div> -->
                </div>
                <div class="option_box">
                  <!-- <div class="title_name">核心金融</div>
                  <div class="line_box">
                    <span class="red_line"></span>
                    <span class="line2"></span>
                  </div> -->
                  <!-- <div class="text" v-for="item in options4" :key="item.name" @click="toRouter(item.router)">{{ item.name }}<img v-if="item.isHot" src="../../static/image/Header/hot.png" /></div> -->
                </div>
              </div>
              <div class="option_detail" v-show="activityFlag == 2">
                <div class="option_box">
                  <!-- <div class="title_name">{{ $t('lang.ProductSolutions.index.kjjr') }}</div>
                  <div class="line_box">
                    <span class="red_line"></span>
                    <span class="line2"></span>
                  </div> -->
                  <div
                    class="text"
                    v-for="item in options5"
                    :key="item.name"
                    @click="toRouter(item.router)"
                  >
                    {{ item.name
                    }}<img
                      v-if="item.isHot"
                      src="../../static/image/Header/hot.png"
                    />
                  </div>
                </div>
                <div class="option_box">
                  <!-- <div class="title_name">金融业务</div>
                  <div class="line_box">
                    <span class="red_line"></span>
                    <span class="line2"></span>
                  </div> -->
                  <!-- <div class="text" v-for="item in options5" :key="item.name" @click="toRouter(item.router)">{{ item.name }}<img v-if="item.isHot" src="../../static/image/Header/hot.png" /></div> -->
                </div>
                <div class="option_box">
                  <!-- <div class="title_name">核心金融</div>
                  <div class="line_box">
                    <span class="red_line"></span>
                    <span class="line2"></span>
                  </div> -->
                  <!-- <div class="text" v-for="item in options5" :key="item.name" @click="toRouter(item.router)">{{ item.name }}<img v-if="item.isHot" src="../../static/image/Header/hot.png" /></div> -->
                </div>
              </div>
              <div class="option_detail" v-show="activityFlag == 3">
                <div class="option_box">
                  <!-- <div class="title_name">{{ $t('lang.ProductSolutions.index.kjjr') }}</div>
                  <div class="line_box">
                    <span class="red_line"></span>
                    <span class="line2"></span>
                  </div> -->
                  <div
                    class="text"
                    v-for="item in options6"
                    :key="item.name"
                    @click="toRouter(item.router)"
                  >
                    {{ item.name
                    }}<img
                      v-if="item.isHot"
                      src="../../static/image/Header/hot.png"
                    />
                  </div>
                </div>
                <div class="option_box">
                  <!-- <div class="title_name">{{ $t('lang.ProductSolutions.index.jryw') }}</div>
                  <div class="line_box">
                    <span class="red_line"></span>
                    <span class="line2"></span>
                  </div> -->
                  <!-- <div class="text" v-for="item in options6" :key="item.name" @click="toRouter(item.router)">{{ item.name }}<img v-if="item.isHot" src="../../static/image/Header/hot.png" /></div> -->
                </div>
                <div class="option_box">
                  <!-- <div class="title_name">{{ $t('lang.ProductSolutions.index.hxjr') }}</div>
                  <div class="line_box">
                    <span class="red_line"></span>
                    <span class="line2"></span>
                  </div> -->
                  <!-- <div class="text" v-for="item in options6" :key="item.name" @click="toRouter(item.router)">{{ item.name }}<img v-if="item.isHot" src="../../static/image/Header/hot.png" /></div> -->
                </div>
              </div>
              <div class="option_detail" v-show="activityFlag == 4">
                <div class="option_box">
                  <!-- <div class="title_name">{{ $t('lang.ProductSolutions.index.kjjr') }}</div>
                  <div class="line_box">
                    <span class="red_line"></span>
                    <span class="line2"></span>
                  </div> -->
                  <div
                    class="text"
                    @click="
                      toRouter('InternetFinancialTestingAndManagementServices')
                    "
                  >
                    {{ $t("lang.ProductSolutions.jrkjrcsc") }}
                  </div>
                </div>
                <div class="option_box">
                  <!-- <div class="title_name">{{ $t('lang.ProductSolutions.index.jryw') }}</div>
                  <div class="line_box">
                    <span class="red_line"></span>
                    <span class="line2"></span>
                  </div> -->
                  <!-- <div class="text">金融科技人才输出</div> -->
                </div>
                <div class="option_box">
                  <!-- <div class="title_name">{{ $t('lang.ProductSolutions.index.hxjr') }}</div>
                  <div class="line_box">
                    <span class="red_line"></span>
                    <span class="line2"></span>
                  </div> -->
                  <!-- <div class="text">金融科技人才输出</div> -->
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <!-- 语言切换 -->
      <div class="language-change">
        <el-select
          popper-class="selectLang"
          size="mini"
          @change="changeLang"
          v-model="value"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: this.$t("lang.header.sy"),
      menuClass: "glyphicon glyphicon-menu-down",
      languageType: "中文简体",
      isShow: false, // 下拉菜单的显隐
      activityFlag: 0,
      navTop: 0,
      options: [
        {
          value: "zh-cn",
          label: "中文简体"
        },
        // {
        //   value: "zh-hk",
        //   label: "中文繁体"
        // },
        {
          value: "en",
          label: "English"
        }
      ],
      value: sessionStorage.getItem("lang") || "zh-cn"
    };
  },
  computed: {
    productList() {
      return [
        {
          imgUrl: "../../static/image/Header/img1.png",
          name: this.$t("lang.ProductSolutions.index.hlwjr"),
          tip: this.$t("lang.header.mxyh")
        },
        {
          imgUrl: "../../static/image/Header/img2.png",
          name: this.$t("lang.ProductSolutions.index.zhxd"),
          tip: this.$t("lang.header.yhxd")
        },
        {
          imgUrl: "../../static/image/Header/img3.png",
          name: this.$t("lang.ProductSolutions.index.szhyxfw"),
          tip: this.$t("lang.header.zlqy")
        },
        {
          imgUrl: "../../static/image/Header/img4.png",
          name: this.$t("lang.ProductSolutions.index.szhcj"),
          tip: this.$t("lang.header.hyszh")
        },
        {
          imgUrl: "../../static/image/Header/img5.png",
          name: this.$t("lang.header.jrkj"),
          tip: this.$t("lang.header.qfwrck")
        }
      ];
    },
    navList() {
      return [
        {
          name: this.$t("lang.header.sy"),
          path: "/"
        },
        {
          name: this.$t("lang.header.cpjjfa"),
          path: "/ProductSolutions"
        },
        {
          name: this.$t("lang.header.zzzs"),
          path: "/CooperativeTranslation"
        },
        {
          name: this.$t("lang.header.jrwm"),
          path: "/JoinUs"
        },
        {
          name: this.$t("lang.header.gyhq"),
          path: "/AboutUs"
        }
      ];
    },
    options1() {
      return [
        {
          name: this.$t("lang.ProductSolutions.kjskxt"),
          router: "CollectionSystem",
          isHot: true
        },
        {
          name: this.$t("lang.ProductSolutions.kjzfxt"),
          router: "PaymentSystem",
          isHot: false
        },
        {
          name: this.$t("lang.ProductSolutions.hwxnkglxt"),
          router: "OverseasVirtualCardManagement",
          isHot: false
        },
        {
          name: this.$t("lang.ProductSolutions.hwyckhxt"),
          router: "OverseasRemoteAccountOpeningSystem",
          isHot: false
        }
      ];
    },
    options2() {
      return [
        {
          name: this.$t("lang.ProductSolutions.qklxt"),
          router: "BlockchainWeb3",
          isHot: false,
          isNew: true
        },
        {
          name: this.$t("lang.ProductSolutions.fxqxt"),
          router: "AMLAntiMoneyLaunderingSystem",
          isHot: false
        },
        {
          name: this.$t("lang.ProductSolutions.sjyhjwyxt"),
          router: "OverseasMobileBankingAndInternetBankingSystem",
          isHot: false
        },
        {
          name: this.$t("lang.ProductSolutions.dzqbxt"),
          router: "OverseasEwalletAndPaymentSystem",
          isHot: false
        }
      ];
    },
    options3() {
      return [
        {
          name: this.$t("lang.ProductSolutions.szrmb"),
          router: "DigitalYuan",
          isHot: false,
          isNew: true
        },
        {
          name: this.$t("lang.ProductSolutions.hlwhxxt"),
          router: "InternetCoreSystem",
          isHot: false
        },
        {
          name: this.$t("lang.ProductSolutions.zjtgxt"),
          router: "FundDepositorySystem",
          isHot: false
        },
        {
          name: this.$t("lang.ProductSolutions.dwqlczhxt"),
          router: "DawanDistrictComprehensiveFinanCialManagementSystem",
          isHot: false
        }
      ];
    },
    options4() {
      return [
        {
          name: "Buy Now Pay Later",
          router: "BuyNowPayLater",
          isHot: true
        },
        {
          name: this.$t("lang.ProductSolutions.wlxf"),
          router: "NetworkConsumptionInstallmentAndCashLoadSystem",
          isHot: false
        },
        {
          name: this.$t("lang.ProductSolutions.xdsplc"),
          router: "CreditApprovalProcessManagementSystem",
          isHot: false
        },
        {
          name: this.$t("lang.ProductSolutions.fkjcmx"),
          router: "CreditRiskControlDecisionModel",
          isHot: false
        },
        {
          name: this.$t("lang.ProductSolutions.dhcs"),
          router: "PostLoanCollectionModel",
          isHot: false
        }
      ];
    },
    options5() {
      return [
        {
          name: this.$t("lang.ProductSolutions.xcxkf"),
          router: "AppAndWeChatSmallProgramDevelopment",
          isHot: true
        },
        {
          name: this.$t("lang.ProductSolutions.zmjtgxt"),
          router: "PartenrRecreitment",
          isHot: false
        },
        {
          name: this.$t("lang.ProductSolutions.hlwqdyx"),
          router: "InternetChannelMarketingPlatform",
          isHot: false
        },
        {
          name: this.$t("lang.ProductSolutions.zhjfglxt"),
          router: "IntegratedIntegralManagementSystem",
          isHot: false
        },
        {
          name: this.$t("lang.ProductSolutions.qyhx"),
          router: "SaasServicePlatform",
          isHot: false
        }
      ];
    },
    options6() {
      return [
        {
          name: this.$t("lang.ProductSolutions.hyyf"),
          router: "ManagementSystemOfMerchantMemberPrepaidCard",
          isHot: true
        },
        {
          name: this.$t("lang.ProductSolutions.dszhjypt"),
          router: "ECommerceIntegratedTradingPlatform",
          isHot: false
        },
        {
          name: this.$t("lang.ProductSolutions.jyjfglxt"),
          router: "EducationPaymentManagementSystem",
          isHot: false
        },
        {
          name: this.$t("lang.ProductSolutions.wyglxt"),
          router: "PropertyManagementSystem",
          isHot: false
        },
        {
          name: this.$t("lang.ProductSolutions.zycf"),
          router: "CentralKitchenCateringDistributionSystem",
          isHot: false
        }
      ];
    }
  },
  mounted() {
    this.navTop =
      this.$refs.navRef.getBoundingClientRect().top +
      this.$refs.navRef.offsetHeight;
  },
  methods: {
    toRouter(ter) {
      this.$router.push(ter);
      this.isShow = false;
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    showDropDown(index) {
      if (index !== 1) {
        this.isShow = false;
        return;
      }
      this.isShow = true;
    },
    hideDropDown(e) {
      // e.pageY：鼠标指针相对页面的偏移量
      if (this.isShow && e.pageY >= this.navTop) this.isShow = false;
    },
    getDropFlag(index) {
      this.activityFlag = index;
    },
    menuClick() {
      if (this.menuClass === "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }, // 语言切换
    changeLang() {
      if (this.value === "en-us") {
        this.value = "zh-cn";
        return;
      }
      this.$i18n.locale = this.value;
      console.log(this.value);
      sessionStorage.setItem("lang", this.$i18n.locale);
      location.reload();
    }
  }
};
</script>
<style scoped>
/* 顶部 */
.header-nav {
  width: 100%;
  height: 100px;
  background: #fff;
  transition: all ease 0.6s;
  display: flex;
  display: -ms-flexbox;
  display: -webkit-box;
  display: -webkit-flex;
  align-items: center;
  -ms-flex-align: center;
  justify-content: center;
  box-shadow: 0px 3px 10px rgba(9, 39, 101, 0.05);
  /* position: absolute;
  top: 0;
  left: 0;
  z-index: 999; */
}

.content {
  width: 1600px;
  height: 100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  display: -ms-flexbox;
  display: -webkit-box;
  display: -webkit-flex;
}

/* 导航栏logo图片 */
.header-nav-logo {
  width: 190px;
  height: 40px;
}
.nav_content {
  position: relative;
}
/* 导航栏 导航容器 */
.header-nav-wrapper {
  height: 40px;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 0px;
  color: #bdc1c9;
  display: flex;
  display: -ms-flexbox;
  display: -webkit-box;
  display: -webkit-flex;
}

/* 导航栏 每个导航 */
/* .header-nav-wrapper > li {
  float: left;
  margin: 0 20px;
  position: relative;
} */
/* 导航栏 每个导航下面的 a 链接 */
.header-nav-wrapper > li > a {
  color: #333;
  font-size: 24px;
  font-weight: 400;
  padding: 20px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
.header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #0f2451;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
.header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
.header-nav-wrapper > li > a:hover {
  color: #092765;
  font-weight: bold;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
.header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
.header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
.header-nav-wrapper > li.active > a {
  color: #092765;
  font-weight: bold;
  text-decoration: none;
  /* border-bottom: 2px solid #092765; */
}
/* 导航栏 每个导航下面的二级导航容器 */
.header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
.header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
.header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
.header-nav-wrapper > li:hover dl {
  display: block;
}
.header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}

.language-change {
  flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  width: 138px;
}

/* 下拉菜单收缩展开 */
@keyframes expand-contract {
  0% {
    opacity: 0;
    /* transform: scaleY(0); */
    height: 0;
    /* // max-height: 0;  ` */
  }
  100% {
    opacity: 1;
    /* transform:scaleY(1); */
    height: 474px;
    /* // max-height: 300px;  // 大于等于下拉菜单的高度 */
  }
}
.dropdown-enter-active {
  animation: expand-contract 0.6s;
}
.dropdown-leave-active {
  animation: expand-contract 0.6s reverse;
}
@keyframes menu {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.dropdown-content {
  position: absolute;
  top: 69px;
  left: -164px;
  display: flex;
  width: 1054px;
  /* transform-origin: 0px 0px; */
  overflow: hidden;
  z-index: 999;
}
.dropdown-content .left {
  width: 274px;
  height: 474px;
  background-color: pink;
  transition: all 0.3s;
}
.dropdown-content .left .option {
  display: flex;
  align-items: center;
  width: 274px;
  height: 95px;
  background-color: #fff;
  box-sizing: border-box;
  text-align: left;
}
.dropdown-content .left .option:hover {
  background-color: #f0f2f3;
  border: 2px solid #001e3a;
  border-width: 0 2px 0 0;
  transition: all 0.3s;
}
.dropdown-content .left .option img {
  width: 40px;
  height: 40px;
  margin: 0 24px;
}
.dropdown-content .left .option .select_box .name {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 5px;
}
.dropdown-content .left .option .select_box .introduce {
  font-size: 14px;
  font-weight: 400;
  color: #8d97a8;
}
.dropdown-content .right {
  width: 780px;
  height: 474px;
  background-color: #fff;
  transition: all 0.3s;
}
.dropdown-content .right .option_detail {
  display: flex;
  justify-content: space-evenly;
}
.dropdown-content .right .option_box {
  width: 200px;
  margin-top: 59px;
  text-align: left;
}
.dropdown-content .right .option_box .title_name {
  font-size: 20px;
  font-family: 苹方;
  font-weight: 500;
  color: #000000;
}
.dropdown-content .right .option_box .line_box {
  margin-top: 24px;
}
.right .option_box .line_box .red_line {
  display: inline-block;
  width: 24px;
  height: 2px;
  background-color: #f53131;
}
.right .option_box .line_box .line2 {
  display: inline-block;
  width: 157px;
  height: 0px;
  border: 1px solid #dbdbdb;
}
.dropdown-content .right .option_box .text {
  margin-top: 24px;
  font-size: 16px;
  font-weight: 500;
  color: #8d97a8;
  cursor: pointer;
}
.dropdown-content .right .option_box .text img {
  width: 34px;
  height: 16px;
  margin-left: 3px;
}
.dropdown-content .dropdown-menu {
  padding: 10px 8px 15px;
  color: white;
  background-color: pink;
  border-radius: 4px;
}
.dropdown-content .dropdown-menu .menuItem {
  width: 100%;
  white-space: nowrap;
  padding: 10px 16px;
  font-size: 16px;
  color: #000;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 4px;
}
.dropdown-content .dropdown-menu .menuItem:hover {
  background-color: #ccc;
}
</style>

<style>
.selectLang .el-select-dropdown__wrap {
  margin-bottom: -18px !important;
}
</style>



// WEBPACK FOOTER //
// src/common/Header.vue